import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { LayoutGapStyleBuilder } from '@angular/flex-layout';
import { CodeInputModule } from 'angular-code-input';
import {
    CurrentCultureInterceptor,
    DebugInterceptor,
    HttpErrorInterceptor
} from './interceptors';
import {
    CustomLayoutGapStyleBuilderService,
    ScrollTopService
} from './services';

@NgModule({
    imports: [
        CommonModule,
        CodeInputModule.forRoot({
            codeLength: 6,
            isCharsCode: false
        })
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CurrentCultureInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DebugInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: LayoutGapStyleBuilder,
            useClass: CustomLayoutGapStyleBuilderService
        }
    ]
})
export class CoreModule {
    /**
     * CoreModule should only be imported once (in AppModule).
     * This will throw an error if anyone accidentally imports
     * this module in a second location.  This is a good place
     * for singleton services and other items that only need to
     * be imported once.
     *
     * Importing the `ScrollTopService` so that the service gets
     * instantiated as a singleton.  But we don't actually need
     * to inject this service anywhere else.  It has no public
     * methods.
     */
    constructor(
        @Optional() @SkipSelf() parentModule: CoreModule,
        _scrollTop: ScrollTopService
    ) {
        if (parentModule) {
            throw new Error(
                'CoreModule has already been loaded.  You should only import Core modules in the AppModule.'
            );
        }
    }
}
